import React, { useState } from 'react';
import { useCurrency } from '../contexts/CurrencyContext';
import { Globe, ChevronDown, Check } from 'lucide-react';

const CurrencySelector = () => {
  const { selectedCurrency, currencies, changeCurrency, getPopularCurrencies } = useCurrency();
  const [isOpen, setIsOpen] = useState(false);

  const currentCurrency = currencies[selectedCurrency];
  const popularCurrencies = getPopularCurrencies();

  const handleCurrencyChange = (currencyCode) => {
    changeCurrency(currencyCode);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 text-gray-700 hover:text-primary transition-colors duration-200 border border-gray-300 rounded-lg hover:border-primary/30"
      >
        <Globe className="w-4 h-4" />
        <span className="text-lg">{currentCurrency?.flag}</span>
        <span className="font-medium">{currentCurrency?.symbol}</span>
        <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 z-50">
          <div className="p-4">
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Choisir une devise</h3>
            
            {/* Devises populaires */}
            <div className="mb-4">
              <h4 className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
                Populaires
              </h4>
              <div className="space-y-1">
                {popularCurrencies.map((currency) => (
                  <button
                    key={currency.code}
                    onClick={() => handleCurrencyChange(currency.code)}
                    className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-left hover:bg-gray-50 transition-colors duration-200 ${
                      selectedCurrency === currency.code ? 'bg-primary/10' : ''
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <span className="text-lg">{currency.flag}</span>
                      <div>
                        <div className="font-medium text-gray-900">{currency.symbol}</div>
                        <div className="text-xs text-gray-500">{currency.name}</div>
                      </div>
                    </div>
                    {selectedCurrency === currency.code && (
                      <Check className="w-4 h-4 text-primary" />
                    )}
                  </button>
                ))}
              </div>
            </div>

            {/* Toutes les devises */}
            <div>
              <h4 className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
                Toutes les devises
              </h4>
              <div className="space-y-1 max-h-48 overflow-y-auto">
                {Object.values(currencies).map((currency) => (
                  <button
                    key={currency.code}
                    onClick={() => handleCurrencyChange(currency.code)}
                    className={`w-full flex items-center justify-between px-3 py-2 rounded-lg text-left hover:bg-gray-50 transition-colors duration-200 ${
                      selectedCurrency === currency.code ? 'bg-primary/10' : ''
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      <span className="text-lg">{currency.flag}</span>
                      <div>
                        <div className="font-medium text-gray-900">{currency.symbol}</div>
                        <div className="text-xs text-gray-500">{currency.name}</div>
                        <div className="text-xs text-gray-400">{currency.region}</div>
                      </div>
                    </div>
                    {selectedCurrency === currency.code && (
                      <Check className="w-4 h-4 text-primary" />
                    )}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CurrencySelector;
